export default "__VITE_ASSET__83QJDU7C__"